module.exports = __webpack_public_path__ + "static/media/desktop-alt.be088180.svg";